/* 🤖 this file was generated by svg-to-ts */
export const matIconAddComment: {
  name: 'add-comment';
  data: string;
} = {
  name: 'add-comment',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M22 4c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4zm-2 13.17L18.83 16H4V4h16v13.17zM13 5h-2v4H7v2h4v4h2v-4h4V9h-4z"/></svg>`
};
